import route from "@/router/index";
import helpers from "../helper"
import {
  ACCESS_TOKEN_NAME,
  ACCESS_TOKEN_EXPIRED,
  AUTHORITIES_NAME,
  USER_NAME,
  USER_ID,
  REDIRECT_URI_NAME,
  SYSTEMS,
  APP_CODE_NAME,
  CLIENT_ID_NAME,
  USER_FULL_NAME,
  RESET_PASSWORD_REQUIRED,
  CLIENT_ID,
  TIME_OTP_EXPIRED
} from "@/constant";
import securityCfg from "@/security/config";
import helper from "../helper";

const security = (function (router) {
  let userName;
  let fullName;
  let authorities;
  let authorizationMapper;
  let authenSuccesUrlRedirect;
  let userId;

  let initAuthorities = function () {
    let authoritiesStore = getAuthoritiesStore();
    authorities = new Map();
    for (let element of authoritiesStore) {
      // let author = element.authority;
      let author = element;
      authorities.set(author, author);
    }
  }

  let initAuthorizationMapper = function () {
    authorizationMapper = [];
    cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper);
  }

  let initAuthenSuccesUrlRedirect = function () {
    if (localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
      authenSuccesUrlRedirect = "/user/reset-password.html";
    } else {
      authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor);
    }
  }

  let initConfig = function () {
    initAuthorizationMapper();
    initAuthenSuccesUrlRedirect();
  }

  let initRouteFilter = function () {
    router.beforeEach((to, from, next) => {
      let _isLogin = isLogin();
      let _fullPath = to.fullPath;
      let _isAuthorized = isAuthorized(_fullPath);
      if (!_isLogin && (_fullPath === "/" || _fullPath.startsWith("/?"))) {
        next({name: 'UserLogin'});
      } else if (_isLogin && (_fullPath === "/" || _fullPath.includes("/login.html"))) {
        const urlParams = new URLSearchParams(window.location.search);
        const urlRedirect = urlParams.get(REDIRECT_URI_NAME);
        const urlClientId = urlParams.get(CLIENT_ID_NAME);
        if (urlRedirect && urlClientId) {
          if (localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
            next({
              path: '/user/reset-password.html',
              query: {'redirect-uri': urlRedirect, 'client-id': urlClientId}
            });
          } else {
            helpers.loadDataSource({
              url: "/system/check-systems",
              isJsonContentType: false,
              dataSubmit() {
                return {
                  userId: localStorage.getItem(USER_ID)
                }
              },
              successCallback: function (response) {
                if (response.data.returnCode == 1) {
                  generateAuthorizationCode(urlRedirect, urlClientId, response.data.data);
                }
              },
              errorCallback: function (error) {
                helpers.handleError(router, error);
              }
            });
          }
        } else {
          next(authenSuccesUrlRedirect);
        }
      } else if (_isAuthorized) {
        if (localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
          if (!_fullPath.includes("/user/reset-password.html")) {
            next({path: '/user/reset-password.html'});
          } else {
            next();
          }
        } else {
          next();
        }
      } else if (!_isLogin) {
        next({name: 'UserLogin'})
      } else {
        next({name: 'page403'});
      }
    });
  }

  let cloneObjConfig = function (origin, target) {
    for (let attr in origin) {
      target[attr] = origin[attr];
    }
  }

  let isLogin = function () {
    return authorities && authorities.size;
  }

  let hasAuthor = function (author) {
    return authorities.has(author);
  }

  let isAuthorized = function (path) {
    let _isAuthorized = true;
    for (let authorCfg of authorizationMapper) {
      if (!(authorCfg.regex instanceof RegExp)) {
        console.log('author regex path undefined');
        continue;
      }
      if (authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === "function") {
        _isAuthorized &= authorCfg.isAuthorized(hasAuthor);
      }
    }
    return _isAuthorized;
  }

  let authLogin = function (access_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword) {
    localStorage.setItem(ACCESS_TOKEN_NAME, access_token);
    localStorage.setItem(ACCESS_TOKEN_EXPIRED, access_token_exp);
    localStorage.setItem(AUTHORITIES_NAME, JSON.stringify(authoritiesStore));
    localStorage.setItem(USER_NAME, userName);
    localStorage.setItem(USER_FULL_NAME, fullName);
    localStorage.setItem(USER_ID, userId);
    if (lastUpdatePassword) {
      localStorage.setItem(RESET_PASSWORD_REQUIRED, lastUpdatePassword);
    }
    initAuthorities();
    setupUserInfor();
    initAuthenSuccesUrlRedirect();
    const urlParams = new URLSearchParams(window.location.search);
    const urlRedirect = urlParams.get(REDIRECT_URI_NAME);
    const urlClientId = urlParams.get(CLIENT_ID_NAME);
    if (urlRedirect && urlClientId) {
      if (lastUpdatePassword) {
        route.push({path: authenSuccesUrlRedirect, query: {'redirect-uri': urlRedirect, 'client-id': urlClientId}});
      } else {
        generateAuthorizationCode(urlRedirect, urlClientId, JSON.parse(systems));
      }
    } else {
      route.push({path: authenSuccesUrlRedirect});
    }
  }

  let generateAuthorizationCode = function (urlRedirect, urlClientId, systems) {
    helpers.loadDataSource({
      url: "/oauth/authorization-code",
      isJsonContentType: false,
      dataSubmit() {
        return {
          client_id: urlClientId
        }
      },
      successCallback: function (response) {
        if (response.data.returnCode == 1) {
          let system = systems.find(each => each.value === urlClientId);
          if (system) {
            window.location.href = `${urlRedirect}?code=${response.data.data}`
          } else {
            route.push({name: 'page403'})
          }
        } else {
          helper.showErrorMessage("No client with requested client id");
          clearLocalStorage();
        }
      },
      errorCallback: function (error) {
        helpers.handleError(router, error);
      }
    });
  }

  let clearLocalStorage = function () {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRED);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_FULL_NAME);
  }

  let authLogout = function () {
    authorities.clear();
    localStorage.removeItem(ACCESS_TOKEN_NAME);
    localStorage.removeItem(ACCESS_TOKEN_EXPIRED);
    localStorage.removeItem(AUTHORITIES_NAME);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(USER_FULL_NAME);
    localStorage.removeItem(RESET_PASSWORD_REQUIRED);
    localStorage.removeItem(TIME_OTP_EXPIRED);
    localStorage.removeItem(CLIENT_ID_NAME);
    localStorage.removeItem(SYSTEMS);
    // localStorage.clear();
    let redirectUri, clientId;
    const urlParams = new URLSearchParams(window.location.search);
    const urlRedirect = urlParams.get(REDIRECT_URI_NAME);
    const urlClientID = urlParams.get(CLIENT_ID_NAME);
    if (urlRedirect && urlClientID) {
      redirectUri = urlRedirect
      clientId = urlClientID;
    }
    route.push({name: 'UserLogin', query: {'redirect-uri': redirectUri, 'client-id': clientId}});
  }

  let getAuthoritiesStore = function () {
    let authoritiesStore;
    try {
      let _authoritiesStr = localStorage.getItem(AUTHORITIES_NAME);
      if (_authoritiesStr) {
        authoritiesStore = JSON.parse(_authoritiesStr);
      } else {
        authoritiesStore = []
      }
    } catch {
      authoritiesStore = [];
    }
    return authoritiesStore;
  }

  let getUserName = function () {
    return userName;
  }

  let getUserId = function () {
    return userId;
  }

  let getFullName = function () {
    return fullName;
  }

  let setupUserInfor = function () {
    userName = localStorage.getItem(USER_NAME);
    fullName = localStorage.getItem(USER_FULL_NAME);
    userId = localStorage.getItem(USER_ID);
  }

  let init = function () {
    initAuthorities();
    initConfig();
    setupUserInfor();
    initRouteFilter();
  }

  init();

  return {
    roles: securityCfg.roles,
    getUserName: getUserName,
    getFullName: getFullName,
    getUserId: getUserId,
    hasAuthor: hasAuthor,
    isAuthorized: isAuthorized,
    isLogin: isLogin,
    authLogin: authLogin,
    authLogout: authLogout,
  }
})(route);

export function roles() {
  return security.roles;
}

export function getUserName() {
  return security.getUserName();
}

export function getFullName() {
  return security.getFullName();
}

export function getUserId() {
  return security.getUserId();
}

export function hasAuthor(author) {
  return security.hasAuthor(author);
}

export function isAuthorized(path) {
  return security.isAuthorized(path);
}

export function authLogin(access_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword) {
  return security.authLogin(access_token, access_token_exp, authoritiesStore, userName, fullName, userId, systems, lastUpdatePassword);
}

export function authLogout() {
  return security.authLogout();
}

export function isLogin() {
  return security.isLogin();
}
